/* OTERVANO final: native gallery, native variant fetch and native product-form remain authoritative.
   No cart request is made here. Links and focus controls work without purchasing automatically. */
(() => {
  if (window.otPdpPremiumLoaded) return;
  window.otPdpPremiumLoaded = true;
  const initialized = new WeakSet();
  const patched = new WeakSet();
  const roots = () => [...document.querySelectorAll('.ot-pdp')];
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  function nativeForm(root) { return root.querySelector('product-info product-form form, product-form form'); }
  function sync(root) {
    const form = nativeForm(root);
    const id = form?.querySelector('[name="id"]')?.value;
    const price = root.querySelector('[data-ot-current-price]');
    const target = document.querySelector('[data-ot-sticky-price]');
    if (target) {
      const visiblePrice = Boolean(id && price && !price.closest('.hidden,[hidden]'));
      target.hidden = !visiblePrice;
      if (visiblePrice) target.textContent = price.textContent.trim();
    }
    root.querySelectorAll('[data-ot22-option]').forEach(link => {
      const selected = id && new URL(link.href, location.origin).searchParams.get('variant') === String(id);
      if (selected) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
    });
    document.dispatchEvent(new CustomEvent('ot:pdp-state', { detail: { root } }));
  }
  function clampQuantity(input, desired) {
    if (!input || !Number.isFinite(desired)) return;
    const min = Number(input.min || 1), step = Math.max(1, Number(input.step || 1));
    const max = input.hasAttribute('max') ? Number(input.max) : Infinity;
    let value = min + Math.floor((Math.max(min, desired) - min) / step) * step;
    if (Number.isFinite(max)) value = Math.min(value, min + Math.floor((max - min) / step) * step);
    if (value >= min && value <= max) {
      input.value = String(value);
      input.closest('quantity-input')?.validateQtyRules?.();
    }
  }
  function bindProductInfo(root) {
    root.querySelectorAll('product-info').forEach(info => {
      if (patched.has(info) || typeof info.buildRequestUrlWithParams !== 'function') return;
      patched.add(info);
      const current = new URL(location.href);
      const metadata = root.querySelector('[data-ot22-preview]');
      const previewId = current.searchParams.get('preview_theme_id') || metadata?.dataset.ot22Preview || '';
      const explicitView = current.searchParams.get('view');
      const suffix = root.querySelector('[data-ot-pdp-template]')?.dataset.otPdpTemplate || '';
      const view = explicitView || suffix;
      const preservePreview = /^\d+$/.test(previewId);
      const preserveView = /^[\w-]+$/.test(view);
      const originalRequest = info.buildRequestUrlWithParams.bind(info);
      info.buildRequestUrlWithParams = (...args) => {
        const url = new URL(originalRequest(...args), location.origin);
        if (url.origin !== location.origin) return originalRequest(...args);
        if (preserveView) url.searchParams.set('view', view);
        if (preservePreview) url.searchParams.set('preview_theme_id', previewId);
        return url.pathname + url.search;
      };
      if (typeof info.updateURL === 'function') {
        const originalUpdateURL = info.updateURL.bind(info);
        info.updateURL = (...args) => {
          originalUpdateURL(...args);
          if (info.dataset.updateUrl === 'false') return;
          const url = new URL(location.href);
          if (preserveView) url.searchParams.set('view', view);
          if (preservePreview) url.searchParams.set('preview_theme_id', previewId);
          history.replaceState(history.state, '', url.pathname + url.search + url.hash);
        };
      }
      if (typeof info.handleUpdateProductInfo === 'function') {
        const originalHandle = info.handleUpdateProductInfo.bind(info);
        info.handleUpdateProductInfo = (...args) => {
          const callback = originalHandle(...args);
          return html => {
            const wanted = Number(info.querySelector('.quantity__input')?.value);
            callback(html);
            clampQuantity(info.querySelector('.quantity__input'), wanted);
            sync(root);
          };
        };
      }
      // Observe only the price and submit button, not the whole document.
      const price = info.querySelector('[id^="price-"]');
      if (price) new MutationObserver(() => sync(root)).observe(price, { childList: true, subtree: true });
    });
  }
  function init() {
    roots().forEach(root => {
      if (!initialized.has(root)) {
        initialized.add(root);
        root.addEventListener('click', event => {
          const returnLink = event.target.closest('[data-ot-pdp-buy]');
          if (returnLink) {
            const target = root.querySelector('variant-selects') || root.querySelector('.product-form__submit');
            if (!target) return;
            event.preventDefault();
            target.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
            const control = target.querySelector('input:checked,select,button,input:not([disabled])') || target;
            control.focus?.({ preventScroll: true });
            return;
          }
          const optionLink = event.target.closest('a[data-ot22-option]');
          if (optionLink) {
            const url = new URL(optionLink.href, location.origin);
            const preview = new URL(location.href).searchParams.get('preview_theme_id') || root.querySelector('[data-ot22-preview]')?.dataset.ot22Preview;
            if (url.origin === location.origin && /^\d+$/.test(preview || '')) {
              url.searchParams.set('preview_theme_id', preview);
              optionLink.href = url.pathname + url.search + url.hash;
            }
          }
        });
        root.addEventListener('change', () => sync(root));
      }
      if (window.customElements) customElements.whenDefined('product-info').then(() => bindProductInfo(root));
      sync(root);
    });
  }
  document.addEventListener('variant:change', () => roots().forEach(sync));
  document.addEventListener('product-info:loaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
